var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.adData.img)?_c('div',{staticClass:"banner-ad",on:{"click":_vm.handleClickBanner}},[_c('img',{attrs:{"src":_vm.adData.img,"alt":"互动广告"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }